/**
 * Created by smizrahi on 24/05/2017.
 */

/**
 * MeanOpinionScoreCalculator
 */

// Parameters
const DELTA_PERCENTAGE = 0.69;
const THRESHOLDS = [4.1, 2.5];
const THRESHOLD_COEFFICIENTS = [6.0, 24.0, 1.0];
const MAXIMUM_MEAN_OPINION_SCORE = 5.0;
const MINIMUM_MEAN_OPINION_SCORE = 0.0;
const CONSTANT_BIT_RATE = 0;
const VARIABLE_BIT_RATE = 1;

/**
 * This class is designed to estimate the scoring using some parameters and live throughput
 * Used in scoring UI in chart to display bar chart
 */
export default class MeanOpinionScoreCalculator {

    /**
     * Constructor
     *
     * @param pConstantBitRate mScore's CBR parameter
     * @param pVariableBitRate mScore's VBR parameter
     * @param pVariableBitRatePercentage mScore's VBR percentage parameter
     * @param pDuration mScore's duration parameter
     *
     * @returns The instance
     */
    constructor(pConstantBitRate, pVariableBitRate, pVariableBitRatePercentage, pDuration) {
        this.mConstantBitRate = pConstantBitRate;
        this.mVariableBitRate = pVariableBitRate;
        const variableBitRateFrequency = 1.0 / (pDuration * pVariableBitRatePercentage);
        this.mTotalVariableBitRate = this.mConstantBitRate == this.mVariableBitRate ? 0 : parseInt(pDuration / variableBitRateFrequency);
        this.mAllowedConstantBitRateDelta = this.mConstantBitRate * DELTA_PERCENTAGE;
        this.mAllowedVariableBitRateDelta = this.mVariableBitRate * DELTA_PERCENTAGE;

        this.mWeightedMeanOpinionScore = 0.0;
        this.mTotalCoefficient = 0.0;
    }

    /**
     * Returns the current mean opinion score
     *
     * @returns {double} Mean opinion score, null if invalid
     */
    getMeanOpinionScore() {
        if (this.mTotalCoefficient > 0.0) {
            return this.mWeightedMeanOpinionScore / this.mTotalCoefficient;
        }
        return null;
    }

    /**
     * Add a throughoput for MOS calculator and returns the mean opinion score
     *
     * @param pThroughput The throughput
     * @returns {number} Mean opinion score
     */
    add(pThroughput) {
        let type = this.getThroughputType(pThroughput);
        let base = 0;
        let allowedDelta = 0;
        switch (type) {
            case VARIABLE_BIT_RATE:
                base = this.mAllowedVariableBitRateDelta;
                allowedDelta = this.mAllowedVariableBitRateDelta;
            break;
            case CONSTANT_BIT_RATE:
                base = this.mConstantBitRate;
                allowedDelta = this.mAllowedConstantBitRateDelta;
            break;
        }
        let delta = base - pThroughput;
        let meanOpinionScore = Math.min(MAXIMUM_MEAN_OPINION_SCORE, Math.max(MINIMUM_MEAN_OPINION_SCORE, (allowedDelta - delta) / allowedDelta * MAXIMUM_MEAN_OPINION_SCORE));
        let coefficient = this.getCoefficient(meanOpinionScore);
        this.mWeightedMeanOpinionScore += coefficient * meanOpinionScore;
        this.mTotalCoefficient += coefficient;

        return meanOpinionScore;
    }

    /**
     * Get the throughput type
     *
     * @param pThroughput A throughput
     * @returns {number} CBR or VBR
     */
    getThroughputType(pThroughput) {
        if (this.mTotalVariableBitRate == 0 || pThroughput < (this.mConstantBitRate + this.mVariableBitRate) / 2.0) {
            return CONSTANT_BIT_RATE;
        }
        return VARIABLE_BIT_RATE;
    }

    /**
     * Get the coefficient for mean opinion score calculation
     *
     * @param pMeanOpinionScore The mean opinion score
     * @returns {number} The coefficient
     */
    getCoefficient(pMeanOpinionScore) {
        if (pMeanOpinionScore >= THRESHOLDS[0]) {
            return THRESHOLD_COEFFICIENTS[0];
        } else if (pMeanOpinionScore <= THRESHOLDS[1]) {
            return THRESHOLD_COEFFICIENTS[1];
        } else {
            return THRESHOLD_COEFFICIENTS[2];
        }
    }
}


// WEBPACK FOOTER //
// ./src/equalone-ui/components/speedometer/MeanOpinionScoreCalculator.js